/**
 * Expose a map of utils function
 */
 export function utils() {
    const _utils = {};
  
    // Get an incremental, unique, index at each method call
    let incrementalIndex = 0;
    _utils.getNextIndex = () => incrementalIndex++;
  
    return _utils;
}

/**
 * Capitalize
 */

export const capitalize = (s) => {
  if (typeof s !== 'string') return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export const addStats = (url) => {
  let tmpStringArray = window.location.href.split('?');

  if (tmpStringArray.length <= 1) {
      return url;
  }

  const parametersString = tmpStringArray[1];
  tmpStringArray = parametersString.split('&');
  let splitParam;

  const statsToRetreive = ['utm_source', 'utm_campaign', 'utm_term'];
  const queries = [];

  for (const param of tmpStringArray) {
      splitParam = param.split('=');
      if(statsToRetreive.includes(splitParam[0])) {
        queries.push(splitParam[0] + '=' + splitParam[1]);
    }
  }

  const path = encodeURIComponent(window.location.href.split('?')[0]);

  return url + '?path=' + path + (queries.length > 0 ? '&' + queries.join('&') : '')
}

/**
 * Handle the scroll given in parameter
 * @param {string} elementId 
 */
export const handleScroll = (elementId) => {

  const params = window.location.href.split('?')[1];

  if(params) {
      const paramsSplit = params.split('&');
      const paramScroll = paramsSplit.find(ps => ps.indexOf('scroll') === 0);
      if(paramScroll) {
          const scrollvalue = paramScroll.split('=')[1];
          if(scrollvalue) {
              document.getElementById(elementId)?.scrollTo({
                  top: scrollvalue,
                  behavior: 'smooth',
              });
          }
      }
  }
};

/**
 * Extract section parameter from url.
 * @returns 
 */
export const extractSectionValue = () => {

  const params = window.location.href.split('?')[1];

  if(params) {
      const paramsSplit = params.split('&');
      const paramSection = paramsSplit.find(ps => ps.indexOf('section') === 0);
      if(paramSection) {
          return paramSection.split('=')[1];
      }
  }
};